import React, { useEffect } from "react";
import LineChart from "Components/Charts/Line/Line";
import Block from "Components/UI/Block/Block";
import { useDashboard } from "./useDashboard";
import { useAppDispatch } from "Redux/store";
import { getDashboardInspectionSubmission } from "Redux/Dashboard/reducer";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";
const InspectionSubmission: React.FC = () => {
  const { data, xAxisLabels, loading } = useDashboard();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getDashboardInspectionSubmission());
  }, [dispatch]);

  if (loading) return <SkeletonLoader height="440px" />;

  return (
    <Block>
      <LineChart
        chartData={data}
        title="Inspection Submission"
        xAxisLabels={xAxisLabels}
      />
    </Block>
  );
};
export default InspectionSubmission;
